import c from './AnnonseSide.module.scss';
import {useContext, useEffect, useRef, useState} from "react";
import siteService from "../services/SiteService";
import ContentPart1 from "../components/frontpage/ContentPart1";
import Helpers from "../helpers/Helpers";
import SiteContext from "../store/siteContext";
import AdvertBlock5 from "../components/frontpage/content-blocks/AdvertBlock5";
import AdvertPopupGeo from "../components/advert/AdvertPopupGeo";
import NyhetsbrevAbonner from "../components/frontpage/NyhetsbrevAbonner";

export default function AnnonseSide(){


	function Intro(){
		return(<div className={c.intro}>
			<h2>Les Båtens Verden #1 digitalt</h2>

			<p>Vær så god! Her kan du lese vår vårutgave av Båtens Verden.
				<br/>
				God lesning!
			</p>
		</div>)
	}

	function Issue() {
		return <div className={c.pdfWrapper}>
			<div style={{
				position: 'relative',
				paddingTop: 'max(90vh)',
				height: '0',
				width: '100%',
				maxHeight: '30vh',
				maxWidth: '98vw'
			}}>
				<iframe allow="clipboard-write"
						sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
						allowFullScreen="true"
						style={{
							position: 'absolute',
							border: 'none',
							width: '100%',
							height: '100%',
							left: '0',
							right: '0',
							top: '0',
							bottom: '0'
						}}
						src="https://e.issuu.com/embed.html?d=_bv2025-1&u=vbmedia"></iframe>
			</div>
		</div>
	}

return <div className={c.root}>
	<br/>
	<br/>
	<br/>
	<AdvertBlock5 adPlacementId={'6720f9fa3475a38100f13066'}/>
	<Intro/>
	<Issue/>
	<AdvertPopupGeo adPlacementId={'6721001a3475a38100f1358a'} name={"bv1-2025"}
					title={'Båtens Verden hjem på døra – til spesialpris'}
					body={<>
						Ingenting er som et trykket båtmagasin rett hjem.
			<br/>
						Som KNBF-medlem koster det kun 290,- for et helt år.
		</>}
					delayUntilShow={9000}
	/>
	<NyhetsbrevAbonner text={"Vinn CoastKey - Meld deg på Båtens Verden nyhetsbrev"}/>
	<br/>
	<br/>
	<br/>
</div>
}